/**
 * @license
 * Copyright 2023 Ada School
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export enum AppRoute {
  Answers = "/answers",
  Avatar = "/avatar",
  Badges = "/badges",
  Base = "/",
  Calendar = "/calendar",
  CalendarEvents = "/calendar-events",
  Certificates = "/certificates",
  Cohorts = "/cohorts",
  TrainingCreator = "/training-creator",
  Courses = "/courses",
  Dashboard = "/dashboard",
  Deliverables = "/deliverables",
  Editor = "/editor",
  FormInstances = "/formInstances",
  Forms = "/forms",
  Free = "/free",
  Gamification = "/gamification",
  InteractiveContent = "/content",
  Invites = "/invites",
  Mentors = "/mentors",
  Metrics = "/metrics",
  Modules = "/modules",
  Notifications = "/notifications",
  Organizations = "/organizations",
  Payments = "/payments",
  Platform = "/platform",
  Programs = "/programs",
  Questions = "/questions",
  Reports = "/reports",
  Schools = "/schools",
  Students = "/students",
  Surveys = "/surveys",
  Taskboard = "/taskboard",
  Trainings = "/trainings",
  Teams = "/teams",
  Tools = "/tools",
  Unauthorized = "/unauthorized",
  Users = "/users",
  Mentoring = "/mentoring",
  BookMentoring = "/book-mentoring",
}

export enum PublicRoute {
  Enroll = "/enroll",
  ValidateEmail = "/validate-email",
  ResendVerification = "/resend-verification",
  ResetPassword = "/reset-password",
  ForgotPasssword = "/forgot-password",
  ConductCode = "/conduct-code",
  ServiceTerms = "/service-terms",
  PrivacyPolicy = "/privacy-policy",
  OSSAttributions = "/oss-attributions",
  Certifications = "/certifications",
  Badges = "/badges",
  SchoolNotFound = "/school-not-found",
  CLILogin = "/cli/login",
  SocialShare = "/social/share",
  LiveSession = "/live-session",
  GradingPolicy = "/grading-policy",
  UserSchools = "/user-schools",
  SchoolCreationSuccess = "/school-creation-success",
  Documents = "/documents",
}

export const InitialRoute = AppRoute.Courses;

export const isPublicRoute = (pathname: string): boolean =>
  pathname.includes(PublicRoute.Enroll) ||
  pathname.includes(PublicRoute.ValidateEmail) ||
  pathname.includes(PublicRoute.ResetPassword) ||
  pathname.includes(PublicRoute.Certifications) ||
  pathname.includes(PublicRoute.CLILogin) ||
  pathname.includes(PublicRoute.SchoolNotFound) ||
  pathname.includes(PublicRoute.SocialShare) ||
  pathname.includes(PublicRoute.OSSAttributions) ||
  pathname.includes(PublicRoute.LiveSession) ||
  pathname.includes(PublicRoute.UserSchools) ||
  pathname.includes(PublicRoute.ResendVerification) ||
  pathname.includes(PublicRoute.SchoolCreationSuccess) ||
  pathname.includes(PublicRoute.Documents) ||
  pathname.includes(PublicRoute.Badges);
